import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { FormattedMessage } from 'react-intl';

import Heading from '../Heading';

import GiftIcon from '../../icons/gift.svg';

import styles from './OrderItemAddedSauce.styl';

const cx = classNames.bind(styles);

class OrderItemAddedSauce extends PureComponent {
  static defaultProps = {
    className: '',
  };

  static propTypes = {
    className: PropTypes.string,
    name: PropTypes.string,
  };

  render() {
    return (
      <div className={cx('OrderItemAddedSauce', this.props.className)}>
        <Heading className={cx('OrderItemAddedSauce__name')} level={5} tagName="div">
          + <FormattedMessage id="sauce" /> {this.props.name}
        </Heading>
        <div className={cx('OrderItemAddedSauce__gift')}>
          <GiftIcon width={16} height={16} />
        </div>
      </div>
    );
  }
}

export default OrderItemAddedSauce;
